<template>
  <BaseSimpleTab :tabs="tabs" />
  <div class='mt-5'>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'TheItemInfoPage',
  data() {
    return {
      tabs: [
        {label: this.$t('global.general_information'), icon: 'info-square', routeName: 'settings_edit_item_route'},
        {label: this.$t('global.activities'), icon: 'file-alt', routeName: 'settings_item_activity_route'},
      ]
    }
  }
}
</script>
